import type { MessageStatus } from '@hilo/contracts';
import styles from './StatusTicks.module.css';

/**
 * Marcas de estado al estilo de WhatsApp: reloj (en cola), ✓ enviado (aceptado por el canal),
 * ✓✓ entregado, ✓✓ en añil leído; «!» no enviado y «?» resultado desconocido. Decorativas: el texto
 * del estado va siempre al lado.
 */
export function StatusTicks({ status }: { status: MessageStatus }) {
  return (
    <svg className={styles.ticks} data-status={status} viewBox="0 0 24 16" aria-hidden="true" focusable="false">
      {(status === 'QUEUED' || status === 'SENDING') && (
        <><circle cx="12" cy="8" r="6" /><path d="M12 5v3.2l2 1.3" /></>
      )}
      {status === 'ACCEPTED' && <path d="m6.5 8.5 3 3 7-7" />}
      {(status === 'DELIVERED' || status === 'READ') && (
        <><path d="m2.5 8.5 3 3 7-7" /><path d="m10.5 11.5 7-7" /><path d="m8.6 9.6 1.9 1.9" /></>
      )}
      {status === 'FAILED' && <><circle cx="12" cy="8" r="6.5" /><path d="M12 4.8v3.8M12 11.2v.1" /></>}
      {status === 'UNKNOWN' && (
        <><circle cx="12" cy="8" r="6.5" /><path d="M10 6.2a2.1 2.1 0 1 1 2.8 2c-.6.3-.8.6-.8 1.3M12 11.4v.1" /></>
      )}
    </svg>
  );
}
